// extracted by mini-css-extract-plugin
export default {"label":"styles_label__xZoBF","iconBox":"styles_iconBox__-BZf9","checked":"styles_checked__nZGC5","tickIcon":"styles_tickIcon__cNoaG"};